module.exports = __webpack_public_path__ + "submenu_index_2.21346b44.png";